import { Paragraph } from '@zillow/constellation-10';

const WizardTipContentRoomForRent = () => {
  return (
    <div data-testid="WizardTipContentRoomForRent">
      <Paragraph css={{ marginBottom: '600' }}>
        Providing the room&apos;s square footage helps renters determine whether the space will work for them.
      </Paragraph>

      <Paragraph>
        Measuring a room&apos;s square footage is simple: just multiply the room&apos;s length by its width.
      </Paragraph>
    </div>
  );
};

export default WizardTipContentRoomForRent;
